import React from "react";
import {Helmet} from "react-helmet-async";
import TestimonalQuote from "../../../../TestimonalQuote/TestimonalQuote";
import {cdn} from "../../../../../consts/cdn";
import {JwPlayer} from "../../../../JwPlayer/JwPlayer.js";
import { FRBanner } from "../../../../Banner/Banner";

//images
const VideoThumbnail1 =
    cdn.images +
    "Testimonials/Patients/661337-FR-A A Patient's Perspective on Recovery.jpg";
const VideoThumbnail2 =
    cdn.images +
    "Testimonials/Patients/661417-FR-A Ready to Live Life Again with vNOTES.jpg";
const VideoThumbnail3 =
    cdn.images +
    "Testimonials/Patients/661345-FR-A A Patient's Perspective on Pain.jpg";
const BannerDesktop =
    cdn.images + "Testimonials/Patients/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "Testimonials/Patients/Banner-Mobile.jpg";

function PatientTestimonial() {
    return (
        <>
            <Helmet>
                <title>vNOTES Hysterectomy</title>
                <meta
                    name="description"
                    content="vNOTES (vaginal natural orifice transluminal endoscopic surgery) is another minimally invasive approach to consider for your hysterectomy and other gynecologic…"
                />
            </Helmet>
            <div className="testimonial">
                <FRBanner
                    imgdesktop={BannerDesktop}
                    imgmobile={BannerMobile}
                    bold1="TÉMOIGNAGES"
                    text1="Patientes"
                    color="#365B7E"
                    openSans="true"
                />
                <div className="content">
                    <div className="patient__video-container patient__video-container--1">
                        <div className="testimonial__content--1">
                            <JwPlayer
                                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/d3f77df0-3710-4159-bc64-d3ba8bfbbc35/661337-FR-A A Patient's Perspect.ism/manifest(format=m3u8-cmaf)"
                                title="Hystérectomie vNOTES : le point de vue d'une patiente sur le rétablissement"
                                image={VideoThumbnail1}
                            ></JwPlayer>
                            <div className="video-description">
                                <p>Hystérectomie vNOTES : le point de vue d'une patiente sur le rétablissement</p>
                            </div>
                        </div>
                    </div>

                    <div className="patient__video-container patient__video-container--2">
                        <div className="testimonial__content--2">
                            <JwPlayer
                                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/faef4c15-223e-4903-a5dd-4a65a9e22b08/661417-FR-A Ready to Live Life A.ism/manifest(format=m3u8-cmaf)"
                                title="Prête à revivre pleinement grâce au vNOTES"
                                image={VideoThumbnail2}
                            ></JwPlayer>
                            <div className="video-description">
                                <p>Prête à revivre pleinement grâce au vNOTES</p>
                            </div>
                        </div>

                        <div className="testimonial__content--2">
                            <JwPlayer
                                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/eea9cb6f-6fa7-497c-9473-3389be012309/661345-FR-A A Patient's Perspect.ism/manifest(format=m3u8-cmaf)"
                                title="Hystérectomie vNOTES : le point de vue d'une patiente sur la douleur"
                                image={VideoThumbnail3}
                            ></JwPlayer>
                            <div className="video-description">
                                <p>Hystérectomie vNOTES : le point de vue d'une patiente sur la douleur</p>
                            </div>
                        </div>
                    </div>

                    <div className="patients__div-review" id="first-patient-testimonial">
                        <TestimonalQuote
                            quote="I was really surprised when I was in recovery, because I could get
                            up on my own and I could move and go to the restroom. The little
                            things you don't expect you would be able to do for a while, I was
                            able to do very, very quickly, I mean right after surgery."
                            quote2="« J'ai vraiment été surprise lorsque j'étais en salle de réveil, parce que je pouvais me lever toute seule, me déplacer et aller aux toilettes. Toutes ces petites choses qu'on ne s'attend pas à pouvoir faire pendant un certain temps, j'ai pu les faire très, très rapidement, c'est-à-dire juste après l'opération. »"
                            name="Patiente vNOTES"
                        />
                    </div>

                    <div className="patients__div-review">
                        <TestimonalQuote
                            quote="The vNOTES procedure and my surgeon made it possible for me to just have a little blip on life and just keep on going, and I feel so much better after the procedure!"
                            quote2="« La procédure vNOTES et mon chirurgien m'ont permis de traverser cette épreuve comme une simple parenthèse dans ma vie, et je me sens tellement mieux depuis l'opération ! »"
                            name="Patiente vNOTES"
                        />

                    </div>
                </div>
            </div>
        </>
    );
}

export default PatientTestimonial;
